import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrl: './radio.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent {
  id = input.required<string>();
  name = input.required<string>();
  label = input<string>('');
  value = input.required<string>();
  selectedValue = input<string>('');
  disabled = input<boolean>(false);

  valueChange = output<string>();

  protected isChecked = computed(() => this.value() === this.selectedValue());

  protected onChange(): void {
    if (!this.disabled()) {
      this.valueChange.emit(this.value());
    }
  }
}
